import { computed, signal } from '@preact/signals-react';
export const savingStateSignal = signal('saved');
export const savingInProgressSignal = computed(() => savingStateSignal.value !== 'saved');
export const savingFailedSignal = computed(() => savingStateSignal.value === 'failed-no-retry');
export const setSavingStateSignal = (newState) => {
    if (newState !== savingStateSignal.value) {
        savingStateSignal.value = newState;
    }
};
